export default "__VITE_ASSET__BTcxVevU__"